import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const SubscriptionSuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/insights/expensive-day');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="text-center p-8"
      >
        <div className="mb-6 text-6xl">🎉</div>
        <h1 className="text-3xl font-bold mb-4">Welcome to Premium!</h1>
        <p className="text-gray-600 mb-8">
          Thank you for subscribing. Redirecting you to your insights...
        </p>
      </motion.div>
    </div>
  );
};

export default SubscriptionSuccessPage;
